__webpack_require__.p = "https://oss.gz-cmc.com/news-static/huacheng/";